"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitize = sanitize;
const PII_PROPERTIES = ["email", "password", "phone", "creditCard", "cardNumber", "cvv", "pin", "secret", "token"].map((prop) => prop.toLowerCase());
function sanitize(obj) {
    const sanitized = {};
    for (const [key, value] of Object.entries(obj)) {
        const lowerKey = key.toLowerCase();
        // Check if the property name contains any PII token
        const containsPII = PII_PROPERTIES.some((piiToken) => lowerKey.includes(piiToken));
        if (containsPII) {
            sanitized[key] = "[REDACTED]";
        }
        else if (typeof value === "object" && value !== null && !Array.isArray(value)) {
            sanitized[key] = sanitize(value);
        }
        else {
            sanitized[key] = value;
        }
    }
    return sanitized;
}
//# sourceMappingURL=sanitize.js.map